"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
;
var AbortionInfoForm = /** @class */ (function (_super) {
    __extends(AbortionInfoForm, _super);
    function AbortionInfoForm(props) {
        var _this = _super.call(this, props) || this;
        var state = form_store_1.default.getState();
        _this.state = { value: {}, error: {} };
        for (var _i = 0, _a = _this.getKeys(); _i < _a.length; _i++) {
            var key = _a[_i];
            _this.state.value[key] = state.data[key];
            _this.state.error[key] = state.error[key];
        }
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            if (_this._isMounted) {
                var newState = { value: {}, error: {} };
                state = form_store_1.default.getState();
                for (var _i = 0, _a = _this.getKeys(); _i < _a.length; _i++) {
                    var key = _a[_i];
                    newState.value[key] = state.data[key];
                    newState.error[key] = state.error[key];
                }
                _this.setState(newState);
            }
        });
        return _this;
    }
    AbortionInfoForm.prototype.getKeys = function () {
        return [
            "abortion_date_week",
            "abortion_date_day",
            "abortion_surgical_year",
            "abortion_surgical_month",
            "abortion_surgical_day",
            "fetal_sac_size",
            "chromosome_examination",
            "abortion_hospital_name"
        ];
    };
    AbortionInfoForm.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    AbortionInfoForm.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    AbortionInfoForm.prototype.render = function () {
        var _a = this.state, value = _a.value, error = _a.error;
        var errorFields = [];
        // エラーメッセージの作成
        for (var field in error) {
            var errors = error[field];
            if (errors.length > 0) {
                errorFields[field] = (react_1.default.createElement("p", { className: "form-error" }, errors[0]));
            }
            else {
                errorFields[field] = "";
            }
        }
        return (react_1.default.createElement("div", { className: "form__container" },
            react_1.default.createElement("div", { className: "form__block" },
                react_1.default.createElement("div", { className: "form__item" },
                    react_1.default.createElement("fieldset", { className: "form__field" },
                        react_1.default.createElement("legend", { className: "form__title" },
                            react_1.default.createElement("span", { className: "form__label" }, "\u6D41\u7523\u6642\u9031\u6570"),
                            react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                        react_1.default.createElement("div", { className: "form__input" },
                            errorFields.abortion_date_week,
                            errorFields.abortion_date_day,
                            react_1.default.createElement("div", { className: "input-set" },
                                react_1.default.createElement("span", { className: "input-set__unit" }, "\u598A\u5A20"),
                                react_1.default.createElement("input", { className: "input-text input-set__s", title: "\u6D41\u7523\u6642\u306E\u9031\u6570\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", type: "text", name: "abortion_date_week", value: value.abortion_date_week, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                                react_1.default.createElement("span", { className: "input-set__unit" }, "\u9031"),
                                react_1.default.createElement("input", { className: "input-text input-set__s", title: "\u6D41\u7523\u6642\u306E\u65E5\u6570\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", type: "text", name: "abortion_date_day", value: value.abortion_date_day, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                                react_1.default.createElement("span", { className: "input-set__unit" }, "\u65E5"))))),
                react_1.default.createElement("div", { className: "form__item" },
                    react_1.default.createElement("fieldset", { className: "form__field" },
                        react_1.default.createElement("legend", { className: "form__title" },
                            react_1.default.createElement("span", { className: "form__label" }, "\u6D41\u7523\u624B\u8853\u6642")),
                        react_1.default.createElement("div", { className: "form__input" },
                            errorFields.abortion_surgical_year,
                            errorFields.abortion_surgical_month,
                            errorFields.abortion_surgical_day,
                            react_1.default.createElement("div", { className: "input-date" },
                                react_1.default.createElement("span", { className: "input-date__text" }, "\u897F\u66A6"),
                                react_1.default.createElement("div", { className: "input-date__box" },
                                    react_1.default.createElement("input", { className: "input-text input-date__year", title: "\u6D41\u7523\u624B\u8853\u3092\u884C\u3063\u305F\u5E74\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", type: "text", name: "abortion_surgical_year", value: value.abortion_surgical_year, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                                    react_1.default.createElement("span", { className: "input-date__sep" }, "\u5E74")),
                                react_1.default.createElement("div", { className: "input-date__box" },
                                    react_1.default.createElement("input", { className: "input-text input-date__short", title: "\u6D41\u7523\u624B\u8853\u3092\u884C\u3063\u305F\u6708\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", type: "text", name: "abortion_surgical_month", value: value.abortion_surgical_month, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                                    react_1.default.createElement("span", { className: "input-date__sep" }, "\u6708")),
                                react_1.default.createElement("div", { className: "input-date__box" },
                                    react_1.default.createElement("input", { className: "input-text input-date__short", title: "\u6D41\u7523\u624B\u8853\u3092\u884C\u3063\u305F\u65E5\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", type: "text", name: "abortion_surgical_day", value: value.abortion_surgical_day, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                                    react_1.default.createElement("span", { className: "input-date__sep" }, "\u65E5")))))),
                react_1.default.createElement("div", { className: "form__item" },
                    react_1.default.createElement("div", { className: "form__title" },
                        react_1.default.createElement("label", { htmlFor: "size", className: "form__label" }, "\u80CE\u56A2\u306E\u5927\u304D\u3055")),
                    react_1.default.createElement("div", { className: "form__input" },
                        errorFields.fetal_sac_size,
                        react_1.default.createElement("div", { className: "input-set" },
                            react_1.default.createElement("input", { className: "input-text input-set__s", type: "text", name: "fetal_sac_size", value: value.fetal_sac_size, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                            react_1.default.createElement("span", { className: "input-set__unit" }, "mm")))),
                react_1.default.createElement("div", { className: "form__item" },
                    react_1.default.createElement("fieldset", { className: "form__field" },
                        react_1.default.createElement("legend", { className: "form__title" },
                            react_1.default.createElement("span", { className: "form__label" }, "\u80CE\u5150\u306E\u67D3\u8272\u4F53\u691C\u67FB\u306E\u5B9F\u65BD")),
                        react_1.default.createElement("div", { className: "form__input" },
                            errorFields.chromosome_examination,
                            react_1.default.createElement("ul", { className: "input-list input-list--vertical" },
                                react_1.default.createElement("li", { className: "input-list__item" },
                                    react_1.default.createElement("label", { className: "input-radio" },
                                        react_1.default.createElement("input", { className: "input-radio__input", type: "radio", name: "chromosome_examination", value: "1", onChange: input_actions_1.default.changeInput }),
                                        react_1.default.createElement("input", { type: "radio", name: "inspecton", className: "input-radio__input" }),
                                        react_1.default.createElement("span", { className: "input-radio__text" }, "\u5B9F\u65BD\u3042\u308A"))),
                                react_1.default.createElement("li", { className: "input-list__item" },
                                    react_1.default.createElement("label", { className: "input-radio" },
                                        react_1.default.createElement("input", { className: "input-radio__input", type: "radio", name: "chromosome_examination", value: "1", onChange: input_actions_1.default.changeInput }),
                                        react_1.default.createElement("span", { className: "input-radio__text" }, "\u5B9F\u65BD\u306A\u3057"))))))),
                react_1.default.createElement("div", { className: "form__item" },
                    react_1.default.createElement("div", { className: "form__title" },
                        react_1.default.createElement("label", { htmlFor: "clinic-name02", className: "form__label" }, "\u6D41\u7523\u624B\u8853\u5B9F\u65BD\u75C5\u9662\u540D"),
                        react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                    react_1.default.createElement("div", { className: "form__input" },
                        errorFields.abortion_hospital_name,
                        react_1.default.createElement("input", { className: "input-text", type: "text", name: "abortion_hospital_name", value: value.abortion_hospital_name, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }))))));
    };
    return AbortionInfoForm;
}(react_1.Component));
exports.default = AbortionInfoForm;
